import React from 'react';
import useCopy from '../useCopy';
import { SLIDE3_ROWS, fmtEur, fmtEur2 } from '../data/carouselLogic';
import { POUCH_SINGLE } from '../assets';

export const ReplaceSlide = ({ price }) => {
  const c = useCopy();
  const shown = price.items.slice(0, SLIDE3_ROWS);
  const more = price.items.length - shown.length;

  return (
    <div className="s-replace">
      <h2 className="rep-title">
        {c.rich('PC_Replace_Title', { products: price.count, perDayEur: fmtEur2(c.lang, price.riiseRaw / 30) })}
      </h2>
      <p className="rep-sub">{c.text('PC_Replace_Sub')}</p>
      <div className="rep-card rep-left">
        <h4>{c.text('PC_Replace_Left', { products: price.count })}</h4>
        <ul>
          {shown.map((x) => (
            <li key={x.name}>
              <span>{x.name}</span>
              <i>{fmtEur(c.lang, Math.round(x.retail))}</i>
            </li>
          ))}
          {more > 0 && (
            <li className="more">
              <span>{c.text('PC_Replace_More', { m: more })}</span>
            </li>
          )}
        </ul>
        <div className="rep-total">
          <small>{c.text('PC_Replace_Approx')}</small> <b>{fmtEur(c.lang, price.retail)}</b>{' '}
          <small>{c.text('PC_Replace_PerMonth')}</small>
        </div>
      </div>
      <div className="rep-card rep-right">
        <h4>{c.text('PC_Replace_Right')}</h4>
        <div className="rep-mid">
          <img className="pc-img rep-pouch" alt="" src={POUCH_SINGLE} />
        </div>
        <div className="rep-total">
          <small>{c.text('PC_Replace_From')}</small> <b>{fmtEur(c.lang, price.riise)}</b>{' '}
          <small>{c.text('PC_Replace_PerMonth')}</small>
        </div>
        <p className="rep-plan">{c.text('PC_Replace_PlanNote', { planName: c.text(`PC_PlanName_${price.planKey}`) })}</p>
      </div>
      <div className="rep-save">{c.text('PC_Replace_Save', { diffEur: fmtEur(c.lang, price.diff) })}</div>
    </div>
  );
};
